import { render, staticRenderFns } from "./StudentNavDrawer.vue?vue&type=template&id=2e80a25d&"
import script from "./StudentNavDrawer.vue?vue&type=script&lang=js&"
export * from "./StudentNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports